import { FormattedMessage } from 'react-intl';

import { GridItem } from '@xing-com/grid';
import { BodyCopy, Hero } from '@xing-com/typography';

import { Styled } from './glossary-header.styles';

export const GlossaryHeader: React.FC = () => (
  <Styled.GridContainer variant="FullSize">
    <GridItem span={12} spanMedium={7}>
      <Hero size="small">
        <FormattedMessage id="CAREER_HUB_GLOSSARY_HEADLINE_TITLE" />
      </Hero>
      <BodyCopy size="medium" sizeConfined="large" noMargin>
        <FormattedMessage id="CAREER_HUB_GLOSSARY_HEADLINE_DESCRIPTION" />
      </BodyCopy>
    </GridItem>
    <GridItem
      span={8}
      start={3}
      spanMedium={5}
      startMedium={8}
      spanLarge={4}
      startLarge={9}
    >
      <Styled.SingleSizeIllustrationHeroSearchFrog />
    </GridItem>
  </Styled.GridContainer>
);
